// extracted by mini-css-extract-plugin
module.exports = {"blog":"BlogGrid_blog__3yvO9","thumb":"BlogGrid_thumb__ibcAV","content":"BlogGrid_content__2wLij","readmoreBtn":"BlogGrid_readmoreBtn__2E-0z"};